import React from "react";
import "./About.scss";

import { images } from "../../constant";

import { AppWrapper, MotionWrapper } from "../../wrapper";

import CV from "../../assets/Pujon Das Auvi_Full Stack Developer .pdf";

const About = () => {
  return (
    <section>
      <h2 className="app__about-title head-text">About</h2>
      <span className="app__about-subtitle head-text">
        My <span>Introduction</span>
      </span>
      <div className="app__about-container">
        <div className="aboutIntro">
          <div className="aboutExperience">
            <h1>
              Who am I<i>?</i>
            </h1>
            <hr />
          </div>
          <p>
            I am Pujon Das Auvi. As a dynamic Software Engineer with a passion
            for crafting exceptional user experiences, I bring a wealth of
            expertise in frontend technologies such as HTML, CSS, JavaScript,
            TypeScript, React, and more to the table. I also have expertise in
            version control system like Git. Beyond front-end technologies, I
            possess a strong command of backend technologies including Node.js,
            MongoDB, Mongoose, Prisma, MySQL, and others, enabling me to deliver
            end-to-end solutions that meet and exceed expectations.
            <br />
            My coding philosophy is rooted in the principles of clean, efficient
            code and adherence to industry best practices. I thrive in
            collaborative environments, where my enthusiasm and dedication drive
            me to contribute to innovative projects that make a real impact.
            Continuous learning is ingrained in my approach, ensuring I remain
            at the forefront of industry trends for both personal and
            professional growth.
            <br />I am eager to embrace new challenges, I am known for my
            dedication, quick learning ability, and willingness to push the
            boundaries of frontend development. For a closer look at my recent
            projects and accomplishments, I invite you to explore my GitHub
            profile. Additionally, you can delve into my background and
            experience through my detailed resume.
          </p>

          <div>
            <button className="button">
              <a href={"https://drive.google.com/file/d/1e-z6sr-J5KuxhWfvcSOjgtIb0TuIdlE2/view?usp=sharing"} target="_blank" rel="noreferrer">
                Resume
              </a>
            </button>
            <button className="button">
              <a href="https://github.com/the-pujon" target="_blank" rel="noreferrer">
                GutHub
              </a>
            </button>
          </div>
        </div>
        <div className="app__about-image">
          <img src={images.profile} alt="" />
        </div>
      </div>
    </section>
  );
};

export default AppWrapper(
  MotionWrapper(About, "app__about"),
  "about",
  "app__whitebg"
);
